// Apple-style type scale. SF Pro resolves natively on Apple devices via
// -apple-system / BlinkMacSystemFont; other platforms fall back gracefully.
export const fontFamily = {
    sans: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro Display', 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    display: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'SF Pro Text', 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    mono: "ui-monospace, SFMono-Regular, 'SF Mono', Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
};
// Larger hero numbers, tighter letter-spacing at big sizes — Apple's signature.
export const fontSize = {
    display: 56,
    h1: 40,
    h2: 32,
    h3: 24,
    h4: 20,
    h5: 18,
    h6: 16,
    bodyLarge: 15,
    body: 14,
    small: 13,
    caption: 12,
    micro: 11,
};
export const fontWeight = {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
};
// Tighter tracking at larger sizes — tailored per scale step.
export const letterSpacing = {
    tighter: '-0.03em',
    tight: '-0.02em',
    snug: '-0.01em',
    normal: '-0.005em',
    wide: '0em',
    wider: '0.02em',
};
export const lineHeight = {
    tight: 1.1,
    snug: 1.25,
    normal: 1.5,
    relaxed: 1.65,
};
//# sourceMappingURL=typography.js.map